import {
	Component,
	OnInit,
	Input,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { ApiService, pluck } from "@app/services/api.service"
import { EventsService } from "@app/services/events.service"
import { environment } from "@env/environment"
import { ModalService } from "@app/services/modal.service"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GuestUserDetailsComponent } from "@app/guest-user-details/guest-user-details.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GuestHoursSchedComponent } from "@app/guest-hours-sched/guest-hours-sched.component"
import { GuestAddMeetingFormComponent } from "@app/guest-add-meeting-form/guest-add-meeting-form.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { PrivacyComponent } from "@app/privacy/privacy.component"

@Component({
	selector: "app-guest-sched",
	imports: [
		COMMON_IMPORTS,
		GuestUserDetailsComponent,
		LangValPipe,
		GuestHoursSchedComponent,
		GuestAddMeetingFormComponent,
		ModalWrapComponent,
		PrivacyComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./guest-sched.component.html",
})
export class GuestSchedComponent implements OnInit {
	isPrivacyOpen: boolean = false
	environment = environment
	meeting_request_with_calendar: boolean = false
	dataObj: any = null
	fdsewrfsdfds: string = ""
	hgfe5ty6hjtgft454tr: string = ""
	saveObj: any = {}
	hideNoCalendarTitle: boolean = false
	hasApprovedCookies: boolean = false

	constructor(
		public eventsService: EventsService,
		private apiService: ApiService,
		protected route: ActivatedRoute,
		public modalService: ModalService
	) {}
	ngOnInit() {
		setTimeout(
			() => {
				location.reload()
			},
			20 * 60 * 1000
		)

		this.route.queryParams.subscribe((params) => {
			Object.keys(params).forEach((key) => {
				this[key] = params[key]
			})
			if (this.fdsewrfsdfds && this.hgfe5ty6hjtgft454tr) {
				this.load()
			}
		})

		this.hasApprovedCookies =
			!!document.cookie &&
			document.cookie
				.split(";")
				.map((it) => it.trim().split("="))
				.some((it) => it[0].indexOf("approveCookies") == 0)
	}
	async load() {
		this.dataObj = await this.apiService.post(
			"guest_get_all_fus",
			this,
			"fdsewrfsdfds,hgfe5ty6hjtgft454tr"
		)
		if (this.dataObj?.website) {
			const website = this.dataObj.website
			if (
				website.indexOf("http://") == -1 &&
				website.indexOf("https://") == -1
			) {
				this.dataObj.website = "http://" + website
			}
		}
		this.meeting_request_with_calendar =
			this.dataObj?.meeting_request_with_calendar

		this.saveObj = {
			fdsewrfsdfds: this.fdsewrfsdfds,
			hgfe5ty6hjtgft454tr: this.hgfe5ty6hjtgft454tr,
		}
	}
	backFromHours(obj: any) {
		this.saveObj = { ...this.saveObj, ...obj }
		this.meeting_request_with_calendar = false
	}

	back() {
		//history.back();
		this.meeting_request_with_calendar = false
	}
	approveCookies() {
		this.hasApprovedCookies = true
		document.cookie = "approveCookies=1"
	}
	refuseCookies() {
		this.hasApprovedCookies = false
		document.cookie = "approveCookies=0"
	}
}
